import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { createStructuredSelector } from 'reselect';
import { SUPER_SPEED_ADDON_WARN_TEXT } from 'swag-client-common/constants';
import { APP_ROUTES } from 'swag-client-common/constants/app-routes';
import { checkoutStarted } from 'swag-client-common/redux/cart/cart.actions';
import { hidePopup } from 'swag-client-common/redux/popup-manager/popup-manager.actions';
import { isSuperSpeedWarningPopupShownSelector } from 'swag-client-common/redux/popup-manager/popup-manager.selector';
import { Component } from './super-speed-warning-popup';
const TITLE = 'Keep in mind!';
const MESSAGE = SUPER_SPEED_ADDON_WARN_TEXT;
const CONFIRM_BTN_TEXT = 'Proceed To Checkout';
const mapStateToProps = createStructuredSelector({
  open: isSuperSpeedWarningPopupShownSelector,
  title: () => TITLE,
  message: () => MESSAGE,
  confirmText: () => CONFIRM_BTN_TEXT
});
const mapDispatchToProps = dispatch => ({
  onConfirm: () => {
    dispatch(hidePopup());
    browserHistory.push(APP_ROUTES.DELIVERY);
    dispatch(checkoutStarted());
  },
  onClose: () => {
    dispatch(hidePopup());
  }
});
export const SuperSpeedWarningPopup = connect(mapStateToProps, mapDispatchToProps)(Component);